/*
 * Copyright (c) 2020. American Express Company
 */

import React, { Component, ReactComponentElement } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

// components
import { ButtonPrimary, ButtonSecondary, IconClose } from '@americanexpress/dls-react';
import ClickableIcon from 'src/bw/clickable-icon/ClickableIcon';
import { HELP_DOMAIN, PRODUCT_NAME } from 'src/utils/constants';
import Typography from '../../components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import './ConfirmationPanel.scss';

export default class ConfirmationPanel extends Component<any> {
    public override render(): ReactComponentElement<any> {
        if (!this.props.open) {
            return null;
        }
        let text: JSX.Element = null;
        let action: string = null;
        let actionButton: string = null;
        let buttonClass: string = null;

        const url: string = `${HELP_DOMAIN}/faq/bank-account-change`;
        const helpLink: JSX.Element = HELP_DOMAIN ? (
            <Typography variant={TypographyVariants.BODY}>
                Need help?{' '}
                <a target="_blank" rel="noopener noreferrer" href={url}>
                    Learn more about deleting accounts
                </a>
            </Typography>
        ) : (
            <Typography variant={TypographyVariants.BODY}>
                Need help? <a href="mailto:support@bodeswell.io">Contact {PRODUCT_NAME} support</a>
            </Typography>
        );

        switch (this.props.confirmationInfo.action) {
            case 'delete':
                action = 'Are you sure you want to delete?';
                actionButton = 'Delete';
                switch (this.props.confirmationInfo.object) {
                    case 'imported':
                        text = (
                            <Typography variant={TypographyVariants.BODY} key="body">
                                Deleting this account will <b>remove the account & the institution</b> it's associated
                                with. This will also permanently remove any data associated with this institution from{' '}
                                {PRODUCT_NAME}.
                            </Typography>
                        );
                        break;
                    case 'manual':
                        text = (
                            <p>
                                Deleting this account will <b>remove this from your projections</b>. You can add this
                                account back at any time.
                            </p>
                        );
                        break;
                }
                break;

            case 'connect':
                action = 'We would love to connect your accounts, but we need you to create a real account first.';
                actionButton = `Sign up for ${PRODUCT_NAME}`;
                buttonClass = '';
                break;
        }

        return (
            <Dialog
                className="confirmation-dialog"
                aria-labelledby="customized-dialog-title"
                open={this.props.open}
                maxWidth="md"
                data-cy="confirmationDialog"
            >
                <DialogContent className="dialog-content">
                    <ClickableIcon
                        className="dialogClose"
                        icon={<IconClose />}
                        onClick={() => {
                            this.props.handleCloseConfirmation();
                        }}
                    />
                    <div className="dialog-inner-container">
                        <Typography variant={TypographyVariants.HEADING_S} key="action">
                            {action}
                        </Typography>
                        {text}
                        <div key="buttons" className="bottom-buttons">
                            <ButtonPrimary
                                className={buttonClass}
                                onClick={() => {
                                    this.props.confirmationInfo.onAction(this.props.confirmationInfo);
                                    this.props.handleCloseConfirmation();
                                }}
                                key="add"
                            >
                                {actionButton}
                            </ButtonPrimary>
                            <ButtonSecondary
                                onClick={() => {
                                    this.props.handleCloseConfirmation();
                                }}
                                key="cancel"
                            >
                                Cancel
                            </ButtonSecondary>
                        </div>
                        {helpLink}
                    </div>
                </DialogContent>
            </Dialog>
        );
    }
}
